import { tx } from '@transifex/native'

tx.init({ token: '1/d18ef11c8021f72c545f0d443a76ffbfbb26f6d7' })

// eslint-disable-next-line import/prefer-default-export
export const changeLanguage = (lng: string) => {
  tx.setCurrentLocale(lng)
}
